import React from 'react';
import { ArrowUp } from 'lucide-react';
export function LandingPage() {
  return <div className="min-h-screen bg-[#B8E6E4] py-12 px-4 sm:px-6 lg:px-8 font-sans" data-id="element-2">
      {/* Main Card */}
      <div className="max-w-3xl mx-auto bg-white rounded-[2rem] border-4 border-slate-700 shadow-2xl overflow-hidden" data-id="element-3">
        <div className="p-8 md:p-12 lg:p-16" data-id="element-4">
          {/* Header Section */}
          <div className="text-center mb-10" data-id="element-5">
            <p className="text-teal-500 font-bold tracking-widest text-sm uppercase mb-4" data-id="element-6">
              For Parents Who Know School Isn't Enough…
            </p>
            <h1 className="text-4xl md:text-5xl font-black text-slate-800 leading-tight mb-4" data-id="element-7">
              Get "Outsmart The System" (Free Video)
            </h1>
            <h2 className="text-2xl md:text-3xl font-bold text-slate-800" data-id="element-8">
              Worried about your child's future?
            </h2>
          </div>

          {/* Images Row */}
          <div className="flex justify-center items-center gap-2 md:gap-4 mb-10 flex-wrap" data-id="element-9">
            {['https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=150&h=150&fit=crop', 'https://images.unsplash.com/photo-1571260899304-425eee4c7efc?w=150&h=150&fit=crop', 'https://images.unsplash.com/photo-1498243691581-b145c3f54a5a?w=150&h=150&fit=crop', 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&h=150&fit=crop', 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=150&h=150&fit=crop'].map((src, index) => <div key={index} className="relative" data-id="element-10">
                <img src={src} alt={`Teen engaged in activities ${index + 1}`} className="w-20 h-20 md:w-24 md:h-24 rounded-full object-cover border-4 border-white shadow-md" data-id="element-11" />
              </div>)}
          </div>

          {/* Body Copy */}
          <div className="space-y-6 text-lg text-slate-700 leading-relaxed mb-10" data-id="element-12">
            <p data-id="element-13">I'm not an expert, just a parent like you.</p>
            <p data-id="element-14">
              As parent of two, who has also worked with teens for years, I can
              tell you that confidence, leadership, and money skills are VERY
              learnable. You just have to make it <strong data-id="element-15">practical</strong> and{' '}
              <strong data-id="element-16">real-world</strong>.
            </p>
            <p data-id="element-17">
              How do I know? Because I've seen teens transform how they handle
              emotions, responsibility, and money.
            </p>
            <p className="font-medium" data-id="element-18">
              If you want to go from "School doesn't teach this…" to "My teen is
              learning how to lead themselves," just enter your email below:
            </p>
          </div>

          {/* CTA Section */}
          <div className="flex flex-col items-center space-y-8" data-id="element-19">
            <button className="w-full md:w-auto bg-slate-700 hover:bg-slate-800 text-white font-black py-5 px-8 rounded shadow-lg transform transition hover:scale-105 text-center group" data-id="element-20">
              <span className="block text-xl md:text-2xl uppercase tracking-wide mb-1" data-id="element-21">
                Help Your Teen Get Ahead in Real Life
              </span>
              <span className="block text-xs font-medium tracking-widest opacity-90 group-hover:opacity-100" data-id="element-22">
                Click to Enter Email
              </span>
            </button>

            {/* Hand-drawn style arrows */}
            <div className="flex gap-6 text-teal-500" data-id="element-23">
              {/* Using SVGs to mimic the hand-drawn arrows from the screenshot */}
              <svg width="40" height="60" viewBox="0 0 40 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="transform -rotate-12" data-id="element-24">
                <path d="M20 55C20 55 22 30 20 10M20 10L5 25M20 10L35 25" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-25" />
              </svg>
              <svg width="40" height="60" viewBox="0 0 40 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="transform -translate-y-2" data-id="element-26">
                <path d="M20 55C20 55 18 30 20 10M20 10L5 25M20 10L35 25" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-27" />
              </svg>
              <svg width="40" height="60" viewBox="0 0 40 60" fill="none" xmlns="http://www.w3.org/2000/svg" className="transform rotate-12" data-id="element-28">
                <path d="M20 55C20 55 20 30 20 10M20 10L5 25M20 10L35 25" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" data-id="element-29" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="max-w-4xl mx-auto mt-12 text-center text-[10px] md:text-xs text-gray-600 space-y-4 px-4" data-id="element-30">
        <p className="font-bold" data-id="element-31">
          Copyright 2025 © Base Case and Build. All rights reserved
        </p>
        <p data-id="element-32">
          <a href="#" className="underline hover:text-gray-800" data-id="element-33">
            Terms
          </a>{' '}
          &{' '}
          <a href="#" className="underline hover:text-gray-800" data-id="element-34">
            Privacy
          </a>
        </p>
        <p className="max-w-3xl mx-auto leading-relaxed opacity-80" data-id="element-35">
          This site is not a part of the Facebook™ website or Facebook™ Inc.
          Additionally, this site is NOT endorsed by Facebook™ in any way.
          FACEBOOK™ is a trademark of FACEBOOK™, Inc.
        </p>
        <p className="max-w-3xl mx-auto leading-relaxed opacity-70" data-id="element-36">
          DISCLAIMER: The sales figures presented on this landing page are our
          personal sales figures and in some cases the sales figures of previous
          or existing students. Please understand these results are not typical.
          We're not implying you'll duplicate them (or do anything for that
          matter). The average person who buys "how to" information gets little
          to no results. We're using these references for exemplary purposes
          only. Your results will vary and depend on many factors including but
          not limited to your background, experience, and work ethic. All
          business entails risk as well as massive and consistent effort and
          action. If you're not willing to accept that, please DO NOT JOIN THIS
          PROGRAM.
        </p>
      </footer>
    </div>;
}